module.exports = __webpack_public_path__ + "static/thpcwhiteelephantmummymain-9560a44ea1ef3bae3a771467e029cf87.jpeg";